"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEARCH_PRESET_CLASSROOM_FAVORITES = exports.SEARCH_PRESET_CLASSROOM_PARTICIPATED = exports.SEARCH_PRESET_CLASSROOM_OWNED = void 0;
var enums_1 = require("../enums");
exports.SEARCH_PRESET_CLASSROOM_OWNED = {
  owned: true
};
exports.SEARCH_PRESET_CLASSROOM_PARTICIPATED = {
  participated: true,
  publish_status: [enums_1.PublishStatusEnum.published]
};
exports.SEARCH_PRESET_CLASSROOM_FAVORITES = {
  favorited: true,
  publish_status: [enums_1.PublishStatusEnum.published]
};
